export default [
    {
      path: '/duiBaJump/index/:paramsCode',
      meta:{
        title: '积分商城'
      },
      component: (resolve) => require(['@/pages/duiBaJump/index'], resolve)
    },
  ]